import 'dayjs/locale/lt';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderTags from '../../components/common/HeaderTags';
import XTable from '../../components/common/XTable';
import { HistoryDialogProvider } from '../../contexts/useHistoryDialog';
import { IVAZDialogProvider } from '../../contexts/useIVAZDialog';
import { PageProvider } from '../../contexts/usePageContext';
import { ReportDialogProvider } from '../../contexts/useReportDialog';
import useTablePage from '../../hooks/useTablePage';
import { useAppDispatch } from '../../redux/hooks';
import { resetHeaderTitle, setHeaderTitle } from '../../redux/header/headerSlice';
import { getTableStart } from '../../redux/iot/iotSlice';

const NAME = 'IoT';

const AdminDevices = () => {
 const { t } = useTranslation();
 const headerDispatch = useAppDispatch();
 const { apiRef, items, rowCount, loading, dispatch } = useTablePage(NAME);

 useEffect(() => {
  headerDispatch(setHeaderTitle(t('menu.devices')));
  return () => {
   headerDispatch(resetHeaderTitle());
  };
 }, [headerDispatch, t]);

 return (
  <PageProvider pageName={NAME}>
   <ReportDialogProvider>
    <HistoryDialogProvider>
     <IVAZDialogProvider>
      <HeaderTags entityKey={NAME} />
      <XTable
       columns={[]}
       apiRef={apiRef}
       table={NAME}
       rows={items}
       rowCount={parseInt(rowCount, 10)}
       fetchData={(data: Record<string, unknown>) =>
        dispatch(getTableStart({ table: NAME, ...data }))
       }
       isServerMode
       loading={loading.getTable || false}
      />
     </IVAZDialogProvider>
    </HistoryDialogProvider>
   </ReportDialogProvider>
  </PageProvider>
 );
};

export default AdminDevices;
